import styled from 'styled-components';
import {
  Form,
} from 'antd';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;
  padding-bottom: 1.5rem;

  & .ant-col,
  & .ant-form-item-control {
    width: 100%;
    max-width: 376px;
  }
`;
